import { getData, postData, } from "@/utils/http";
import config from "@/config"
export default {
	namespaced: true,
	state: {
		tableLoading: true,
		addLoading: false,
		activeItem: null,
		tableList: [],
		name:"",
		idCard:"",
		pageIndex:1,
		total:0
	},
	mutations: {
		CHANGE_TABLE_LOADING(state, tableLoading) {
			state.tableLoading = tableLoading;
		},
		CHANGE_ADD_LOADING(state, addLoading) {
			state.addLoading = addLoading;
		},
		CHANGE_TABLE_DATA(state, changeData) {
			state.tableList = changeData.data.rows;
			state.total = changeData.total;
		},
		CHANGE_ACTIVE_ITEM(state, item) {
			state.activeItem = item;
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData["changeKey"] == "orgId" && typeof changeData["data"] != "object") {
				state[changeData["changeKey"]] = [changeData["data"]];
			} else {
				state[changeData["changeKey"]] = changeData["data"];
			}
		},
		CHANGE_TABLE_INDEX(state, value) {
			state.pageIndex = value;
		}
	},
	actions: {
		//获取内部车辆列表
		getList({ commit, state },data) {
			return new Promise((resolve) => {
				getData(`logistics/driver/page?name=${data.name}&idCard=${state.idCard}&page=${state.pageIndex}&size=${config.pageSize}&deptId=${data.deptId}`).then((res) => {
					if (res.state == 1) {
						commit("CHANGE_TABLE_DATA", res);
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},



		//写入当前操作条目
		setActiveItem({ commit }, item) {
			commit("CHANGE_ACTIVE_ITEM", item)
		},

		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit("CHANGE_SEARCH_COLL", changeData)
		},
		//修改分页
		setPageIndex({ commit }, value) {
			commit("CHANGE_TABLE_INDEX", value)
		},
		//修改添加loading
		changeAddLoading({ commit }, value) {
			commit("CHANGE_ADD_LOADING", value)
		},
		//修改添加loading
		changeListLoading({ commit }, value) {
			commit("CHANGE_TABLE_LOADING", value)
		}

	}
}
